import api from '../../libs/api'
import { getP } from 'redux-polyglot'

export const loadChannels = () => dispatch => {
  return Promise.all([dispatch(loadUserChannels())])
}

export const FETCH_CHANNELS_REQUEST = 'TICKET_NEW/FETCH_CHANNELS_REQUEST'
export const FETCH_CHANNELS_SUCCESS = 'TICKET_NEW/FETCH_CHANNELS_SUCCESS'
export const FETCH_CHANNELS_FAILURE = 'TICKET_NEW/FETCH_CHANNELS_FAILURE'

export const fetchChannelsRequest = () => ({
  type: FETCH_CHANNELS_REQUEST,
})

const fetchChannelsSuccess = payload => ({
  type: FETCH_CHANNELS_SUCCESS,
  payload,
})

export const fetchChannelsFailure = error => ({
  type: FETCH_CHANNELS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const STEP_THREE_FOCUS_POSITION = 'TICKET_NEW/STEP_THREE_FOCUS_POSITION'
export const STEP_THREE_FOCUS = 'TICKET_NEW/STEP_THREE_FOCUS'
export const STEP_THREE_SELECT = 'TICKET_NEW/STEP_THREE_SELECT'

export const focusPositionStepThreeRequest = position => ({
  type: STEP_THREE_FOCUS_POSITION,
  payload: {
    position,
  },
})

export const focusTypePositionStepThree = pos => (dispatch, getState) => {
  dispatch(focusPositionStepThreeRequest(pos))
}

export const stepThreeSelectRequest = id => ({
  type: STEP_THREE_SELECT,
  payload: {
    id,
  },
})

export const stepThreeSelect = id => (dispatch, getState) => {
  dispatch(stepThreeSelectRequest(id))
}

export const focusStepThreeRequest = id => ({
  type: STEP_THREE_FOCUS,
  payload: {
    id,
  },
})

export const focusTypeStepThree = id => (dispatch, getState) => {
  dispatch(focusStepThreeRequest(id))
}

export const loadUserChannels = () => (dispatch, getState) => {
  dispatch(fetchChannelsRequest())
  return api
    .getChannels()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          let channels = {
            byId: {},
            allIds: [],
          }
          response.channels.forEach(channel => {
            const processed = {
              id: channel.id,
              no: channel.stb_number,
              name: channel.name,
              img: channel.img.custom,
              isSelected: false,
            }
            channels.byId[processed.id] = processed
            channels.allIds.push(processed.id)
          })
          return dispatch(fetchChannelsSuccess(channels))
        } else {
          return dispatch(fetchChannelsFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchChannelsFailure(
            getP(getState()).t('support_app.error_loading_ticket_types', {
              _: 'An error occurred while retrieving ticket types',
            })
          )
        )
    )
}

export const DISMISS_ERROR = 'TICKET_NEW/DISMISS_ERROR'
export const dismissError = () => ({
  type: DISMISS_ERROR,
})
